import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=d7349320&"
import script from "./Recover.vue?vue&type=script&lang=js&"
export * from "./Recover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7349320')) {
      api.createRecord('d7349320', component.options)
    } else {
      api.reload('d7349320', component.options)
    }
    module.hot.accept("./Recover.vue?vue&type=template&id=d7349320&", function () {
      api.rerender('d7349320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Recover.vue"
export default component.exports